<template>
	<el-drawer
		class="breath-operate-table"
	    :title="title" 
	    :visible.sync="dialog_visible"
	    :wrapperClosable="false"
		size="800px"
	    direction="rtl">
		<section class="header">
			<div class="tools">
				<div class="tools-item">
					<span class="label">坐席账号：</span>
					<el-input v-model="list_query.account" placeholder="坐席账号" style="width: 200px;" size="small" clearable></el-input>
				</div>
				<div class="tools-item">
					<span class="label">账号类型：</span>
					<el-select v-model="list_query.userType" placeholder="请选择" size="small" clearable filterable>
					    <el-option v-for="(item,index) in user_type_list" :key="index" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</div>
			</div>
			<el-button type="primary" size="small" @click.stop="onSearch">查询</el-button>
		</section>
		<section class="table">
			<table-pagination
			    ref="operateTable"
			    pagination
			    :data="list"
			    :column="column"
			    :total="total"
			    :page.sync="list_query.pageNum"
			    :limit.sync="list_query.pageSize"
				 v-loading="loading"
				 layout="total, prev, pager, next"
				@selection-change="handleSelectionChange"
			    @pagination="getList" />
		</section>
		<div class="footer" style="float: right; ">
			<el-button @click="onCancel" size="mini">取 消</el-button>
			<el-button type="primary" @click="onSave" size="mini">确定</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import { tableMixin } from "utils/mixins";
	export default {
		props:['title','childBrand'],
		mixins:[tableMixin],
		data() {
			return {
				loading:false,
				dialog_visible: false,
				list_query:{
					account:'',
					userType:'',
					pageNum:1,
					pageSize:10
				},
				total:0,
				list:[],
				column:[
					 { label: '选择', prop: 'selection', type: 'selection',align:'left' },
					 {
					 	label: '序号',
					 	width: 100,
					 	render: (h, scope) => {
					 		return <span>{((this.list_query.pageNum - 1) * this.list_query.pageSize) + (scope.$index + 1)}</span>
					 	}
					 },
					 { label: '坐席账号', prop: 'account' },
					 { label: '坐席昵称', prop: 'nickname' },
					 { 
						 label: '账号类型',
						 prop: 'userType',
						 render: (h,scope) => {
							 return <el-tag type="info">{this.getUserTypeName(scope.row.userType)}</el-tag>
						 }
						  
					 },
				],
				multipleSelectionAll: [], // 所有选中的数据包含跨页数据
				multipleSelection: [], // 当前页选中的数据
				idKey: "userId", // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
				user_type_list:[
					{name:'超级管理员',id:'1'},
					{name:'普通用户',id:'0'},
					{name:'品牌管理员',id:'2'}
				]
				
			}
		},
		methods: {
			onSave(){
				this.changePageCoreRecordData();
				if (this.multipleSelectionAll.length <= 0) {
					this.$message({
						message: "无勾选数据！",
						type: "warning"
					});
					return;
				}
				// if(this.title == '指定分配坐席') {
				// 	if(this.multipleSelectionAll.length > 1) {
				// 		this.$message.error('指定坐席只允许选定单个坐席');
				// 		return;
				// 	}
				// }
				this.$emit("confirmEvent",this.multipleSelectionAll)
			},
			onCancel(){
				this.dialog_visible = false;
			},
			onShow(){
				this.dialog_visible = true;
				this.$nextTick(()=> {
					this.$refs.operateTable.$refs.elTable.clearSelection();
					this.multipleSelectionAll = [];
					this.multipleSelection = [];
					this.list_query.pageNum = 1;
					this.getList()
				})
			},
			onSearch(){
				this.list_query.pageNum = 1;
				this.getList()
			},
			handleSelectionChange(row) {
				this.multipleSelection = row;
			},
			getUserTypeName(id){
				let results = this.user_type_list.filter(el => el.id == id);
				if(results.length == 0) return '--';
				return results[0].name;
			},
			getList(val){
				if(val){
					this.list_query.pageNum = val.page
					this.changePageCoreRecordData();
				}
				let params = {
					data: {
						brandIdentify:this.$store.getters.userInfo.brandIdentify,
					    account: this.list_query.account,
					    userType: this.list_query.userType,
					},
					orderBy: null,
					pageNum: this.list_query.pageNum,
					pageSize: this.list_query.pageSize
				}
				if(this.childBrand){
					params.data.brandList = [this.childBrand];
				}
				this.$api.getAllPlatformUserList(params).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.list;
					this.total = res.total;
					setTimeout(() => {
						this.setSelectRow('operateTable');
					}, 20);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.breath-operate-table {
		.header {
			padding: 0 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.tools {
				display: flex;
				.tools-item {
					&:nth-of-type(2){
						margin-left: 15px;
					}
				}
			}
			.label {
				font-size: 14px;
			}
		}
		.table {
			margin: 0 20px;
			margin-top: 20px;
			border-top: solid 5px #eff4f5
		}
		.footer {
			padding: 0 20px;
		}
	}
</style>
